'use client';

import React from 'react';

const CookieButton: React.FC = () => {
  const handleClick = () => {
    // Trigger CookieYes modal to open
    if (typeof window !== 'undefined' && (window as any).CookieConsent) {
      (window as any).CookieConsent.show();
    }
  };

  return (
    <button 
      className="cky-banner-element"
      onClick={handleClick}
    >
      Cookies
    </button>
  );
};

export default CookieButton; 